<ui-page-bar
	[title]="envelopeName()"
	[editTitle]="editEnvelopeName()"
	(titleChange)="onEnvelopeNameChange($event)"
	[titlePlaceholder]="'E-Signing'"
>
	<ui-button
		pre-title
		icon="arrow-back"
		preset="EXTRA_LOW_EMPHASIS"
		label="Back"
		(click)="goBack()"
	/>

	<ui-status [status]="status()" title-action />
	<div actions class="flex gap-2">
		<ui-button
			*ngIf="signItUpdateFlowFeatureFlagEnabled_()"
			[loading]="updateActionButton().loading"
			(click)="updateActionButtonClick()"
			[label]="updateActionButton().text"
			[icon]="updateActionButton().icon"
			[preset]="updateActionButton().preset"
			[color]="updateActionButton().color"
		/>
		<ui-button
			[loading]="primaryActionButton().loading"
			(click)="primaryActionButtonClick()"
			[label]="primaryActionButton().text"
			[icon]="primaryActionButton().icon"
			[preset]="primaryActionButton().preset"
			[color]="primaryActionButton().color"
		/>
		<app-e-signing-status-actions-dropdown
			size="md"
			[status]="status()"
			[envelopeId]="envelopeId()"
			(renameClick)="onRenameClick()"
		/>
	</div>
</ui-page-bar>
